const postMessagePromises = {};
function generateGuid(){
    /**
     * @return {string}
     */
    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

function postMessagePromised(targetWindow, message, targetOrigin) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid]['resolve'] = resolve;
        postMessagePromises[newGuid]['reject'] = reject;
        targetWindow.postMessage(message, targetOrigin);
    });
    return postMessagePromises[newGuid].promise;
}

var setCurrentDarkMode = () => {};
export function setDarkModeStateListener(darkModeStateListener) {
  setCurrentDarkMode = darkModeStateListener;
}

export async function getDarkModeStatus() {
    return await postMessagePromised(window.parent, {
        method: "getDarkModeStatus",
        args: {}
    }, "*");
}

export async function getCycleDataFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getCycleDataFromParent',
        args: {}
    }, '*');
}

export async function getAPIGatewayDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getAPIGatewayDataFromParent',
        args: args
    }, '*');
}

export function setSelectedCycle(selectedCycle) {
    window.parent.postMessage({
        method: 'setSelectedCycle',
        args: {selectedCycle: selectedCycle}
    }, "*");
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

const subscribeAbleEvents = {
    "sendCycleDataToChild": sendCycleDataToChild,
    "sendApiGatewayResponse": sendApiGatewayResponse,
    "sendDarkModeStatus": sendDarkModeStatus
}

function sendDarkModeStatus(data) {
    setCurrentDarkMode(data.childData.capability)
}

function sendCycleDataToChild(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendApiGatewayResponse(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

export function publishClientSideMetrics(args) {
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: args
    }, "*");
}


// WEBPACK FOOTER //
// ./src/components/handler/ParentDataHandler.js